import React from "react";
import { useForm, useWatch } from "react-hook-form";

export const withUseFormHook = (Component) => {
  return (props) => {
    const form = useForm();
    const values = useWatch({ control: form.control });
    return <Component {...props} {...values} form={form} />;
  };
};
